/* eslint-disable */
import { makeAutoObservable } from 'mobx';
import { configure } from 'mobx';

import { api } from '../api';
import { user_t, app_data_t, instructionPopup_translations_t } from '../logic/types';
import M from 'materialize-css';

configure({ enforceActions: 'never' });

interface languages_t {
    en: string;
    fr: string;
    it: string;
    de: string;
}
interface instructions_data_t {
    state: 'init' | 'loading' | 'error' | 'success';
    selectedPageLang: string;
    selectedModalLang: string;
    modalTranslations: any | null;
    pageTranslations: any | null;
    langList: any;
    editPageTranslations: boolean;
    editModalTranslations: boolean;
    availableLangList: null | string[];
}

class InstructionStore {
    constructor() {
        makeAutoObservable(this);
    }

    data: instructions_data_t = {
        state: 'init',
        editPageTranslations: false,
        editModalTranslations: false,
        selectedPageLang: 'en',
        selectedModalLang: 'en',
        modalTranslations: {
            INSTRUCTIONS: '',
            'HELP BUTTON': '',
            'click to see what is your current task': '',
            'NEXT TASK BUTTON': '',
            'when task finished, click to proceed': '',
            'CLOSE BUTTON': '',
            'click to close popup window': '',
        },
        pageTranslations: {
            'HELP BUTTON': '',
            'click to see what is your current task': '',
            'NEXT TASK BUTTON': '',
            'when task finished, click to proceed': '',
            'CLOSE BUTTON': '',
            'click to close popup window': '',
        },
        langList: {
            Arabic: {
                name: 'Arabic',
                code: 'ar',
                nativeName: 'العربية',
            },
            Chinese: {
                name: 'Chinese',
                code: 'zh',
                nativeName: '中文 (Zhōngwén), 汉语, 漢語',
            },
            Czech: {
                name: 'Czech',
                code: 'cs',
                nativeName: 'česky, čeština',
            },
            Danish: {
                name: 'Danish',
                code: 'da',
                nativeName: 'dansk',
            },

            Dutch: {
                name: 'Dutch',
                code: 'nl',
                nativeName: 'Nederlands, Vlaams',
            },
            Filipino: {
                name: 'Filipino',
                code: 'tg',
            },
            Thai: {
                name: 'Thai',
                code: 'th',
            },
            English: {
                name: 'English',
                code: 'en',
                nativeName: 'English',
            },

            Finnish: {
                name: 'Finnish',
                code: 'fi',
                nativeName: 'suomi, suomen kieli',
            },
            French: {
                name: 'French',
                code: 'fr',
                nativeName: 'français, langue française',
            },

            German: {
                name: 'German',
                code: 'de',
                nativeName: 'Deutsch',
            },
            Greek: {
                name: 'Greek, Modern',
                code: 'el',
                nativeName: 'Ελληνικά',
            },

            Hungarian: {
                name: 'Hungarian',
                code: 'hu',
                nativeName: 'Magyar',
            },

            Italian: {
                name: 'Italian',
                code: 'it',
                nativeName: 'Italiano',
            },
            Japanese: {
                name: 'Japanese',
                code: 'ja',
                nativeName: '日本語 (にほんご／にっぽんご)',
            },

            Korean: {
                name: 'Korean',
                code: 'ko',
                nativeName: '한국어 (韓國語), 조선말 (朝鮮語)',
            },
            Malaysian: {
                name: 'Malaysian',
                code: 'my',
            },
            Polish: {
                name: 'Polish',
                code: 'pl',
                nativeName: 'polski',
            },
            Brazilian: {
                name: 'Brazilian',
                code: 'br',
            },

            Portuguese: {
                name: 'Portuguese',
                code: 'pt',
                nativeName: 'Português',
            },

            Romanian: {
                name: 'Romanian, Moldavian, Moldovan',
                code: 'ro',
                nativeName: 'română',
            },
            Russian: {
                name: 'Russian',
                code: 'ru',
                nativeName: 'русский язык',
            },

            Serbian: {
                name: 'Serbian',
                code: 'sr',

                nativeName: 'српски језик',
            },

            Slovak: {
                name: 'Slovak',
                code: 'sk',
                nativeName: 'slovenčina',
            },

            Spanish: {
                name: 'Spanish; Castilian',
                code: 'es',
                nativeName: 'español, castellano',
            },

            Swedish: {
                name: 'Swedish',
                code: 'sv',
                nativeName: 'svenska',
            },

            Turkish: {
                name: 'Turkish',
                code: 'tr',
                nativeName: 'Türkçe',
            },
        },
        availableLangList: null,
    };

    getModalTranslations = async () => {
        this.data.state = 'loading';
        try {
            const {
                data: { translations, fallback },
            } = await api.getTranslations(this.data.selectedModalLang, 'modalTranslation');
            if (fallback || !translations.Items[0]) {
                this.data.modalTranslations = {
                    INSTRUCTIONS: '',
                    'HELP BUTTON': '',
                    'click to see what is your current task': '',
                    'NEXT TASK BUTTON': '',
                    'when task finished, click to proceed': '',
                    'CLOSE BUTTON': '',
                    'click to close popup window': '',
                };
            } else {
                this.data.modalTranslations = translations.Items[0];
            }
            this.data.state = 'success';
        } catch (error) {
            this.data.state = 'error';
            M.toast({ html: 'An error happened. Could not load languages.', classes: 'red' });
        }
    };

    getPageTranslations = async () => {
        this.data.state = 'loading';
        try {
            const {
                data: { translations, fallback },
            } = await api.getTranslations(this.data.selectedPageLang, 'pageTranslation');
            if (fallback || !translations.Items.length) {
                this.data.pageTranslations = {
                    'Thank you for participating': '',
                    'Please follow these steps for a successful installation': '',
                    'At the end of the tutorial you will be able to click on the': '',
                    'button which will transfer you to the Chrome Web Store, where EyeSee extension needs to be installed': '',
                    Continue: '',
                    'Click on the Add to Chrome button next to the EyeSee Research - UX Capture Chrome extension': '',
                    'Click on the “Add extension” button to have it installed on your Chrome browser': '',
                    Next: '',
                };
            } else {
                this.data.pageTranslations = translations.Items[0];
            }
            this.data.state = 'success';
        } catch (error) {
            this.data.state = 'error';
            M.toast({ html: 'An error happened. Could not load languages.', classes: 'red' });
        }
    };

    saveTranslation = async (slectedLang: string, type: 'modalTranslation' | 'pageTranslation', translation: any) => {
        this.data.state = 'loading';
        try {
            const response = await api.saveLanguages(slectedLang, type, translation);
            this.data.state = 'success';
            M.toast({ html: 'Success! you successfully edited translation', classes: 'teal lighten-2' });
        } catch (err) {
            this.data.state = 'error';
            M.toast({ html: 'An error happened. Could not save translation.', classes: 'red' });
        }
        this.data.editPageTranslations = false;
    };
    getAvailableLangList = async () => {
        const {
            data: {
                translations
            },
        } = await api.getAvailableLangList();
        // let filteredLangCode = translations.map((item: any) => item.langCodes);
        this.data.availableLangList = translations;
    };
}

export let instructionStore = new InstructionStore();
export let instructionStoreData = instructionStore.data;
